var render = function render(){var _vm=this,_c=_vm._self._c;return _c('smart-lesson',{attrs:{"value":_vm.value,"disabled":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }